import { gql } from "@apollo/client";

export const GET_FEE_CODES = gql`
  query {
    resourceFees {
      values {
        allowed
        description
        feeCode
        name
        feeType
        hasDefaultFeePrice
        ticketable
        feeType
        travelComponent
        canBeManuallyAdded
        feeApplication
        taxApplication
      }
    }
  }
`;
